import { render } from "./securitygatepass.vue?vue&type=template&id=7b44edb8&scoped=true"
import script from "./securitygatepass.vue?vue&type=script&lang=js"
export * from "./securitygatepass.vue?vue&type=script&lang=js"

import "./securitygatepass.vue?vue&type=style&index=0&id=7b44edb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b44edb8"]])

export default __exports__